import {action, makeObservable, observable} from "mobx";
import {SwiperAnimationConfig} from "../../../../services/configurations/config-data-sections/arenas.configuration";

export class SparkSwiperSwipeAnimationModel {
    private triggerDelay: number;
    public individualAnimationDuration: number;
    public animationAppearances: number;
    private delayTimeoutRef?: any;

    @observable.ref
    public isAnimatedSwipingInProgress: boolean = false;

    constructor(swiperAnimationConfig: SwiperAnimationConfig) {
        this.triggerDelay = swiperAnimationConfig.triggerDelay;
        this.individualAnimationDuration = swiperAnimationConfig.individualAnimationDuration;
        this.animationAppearances = swiperAnimationConfig.animationAppearances;
        makeObservable(this);
    }

    @action
    public startAnimatedSwiping() {
        this.delayTimeoutRef = setTimeout(() => {
            this.isAnimatedSwipingInProgress = true;
        }, this.triggerDelay);
    }

    @action
    public stopAnimatedSwiping() {
        this.isAnimatedSwipingInProgress = false;
        this._clearTimers();
    }

    private _clearTimers() {
        if (this.delayTimeoutRef) {
            clearTimeout(this.delayTimeoutRef);
        }

    }
}